import { render, staticRenderFns } from "./ParticipacionDataRegisterChangeInscription.vue?vue&type=template&id=7f125964&scoped=true"
import script from "./ParticipacionDataRegisterChangeInscription.vue?vue&type=script&lang=js"
export * from "./ParticipacionDataRegisterChangeInscription.vue?vue&type=script&lang=js"
import style0 from "./ParticipacionDataRegisterChangeInscription.vue?vue&type=style&index=0&id=7f125964&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f125964",
  null
  
)

export default component.exports